import { useCustomRoomContext } from '../CustomRoomContext'
import React from 'react'

const ProductDetails = () => {
  const { productDetails, bidAmount, auctionDuration, acceptedBidAmount, acceptedName } = useCustomRoomContext()

  if (!productDetails) return null

  return (
    <>
      {acceptedName && <div className="text-xl font-semibold text-amber-600 mt-4">{acceptedName} won</div>}
      <div className="absolute bottom-20 left-2 z-30 w-[calc(100%-1rem)] pr-2">
        <div className="flex justify-between items-center">
          {/* Left side: Host info */}
          <div className="flex items-center space-x-2">
            {productDetails.hostImage && (
              <img
                src={productDetails.hostImage}
                alt={productDetails.hostName}
                className="w-16 h-16 rounded-md object-cover"
              />
            )}
            <div className="flex flex-col">
              <p className="text-sm font-bold">{productDetails.title}</p>
              <p className="text-sm font-bold">{productDetails.category}</p>
              <p className="text-sm font-semibold">{productDetails.price}</p>
            </div>
          </div>

          {/* Right side: Bid amount and time */}
          <div className="text-right">
            <p className="text-sm font-bold">₹ {acceptedBidAmount || bidAmount}</p>
            <p className="text-sm text-gray-600">{auctionDuration}</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductDetails
